import Box from '@mui/material/Box';
import BoxIcon from '@shared/components/BoxIcon';
import AppDataGrid from '@shared/components/DataGrid';
import { createServicesColumns, WorkPauseBlock } from '../features/service/entity';
import { Stack } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteServiceDialog from '../features/service/components/DeleteServiceDialog';
import { useServicesQuery } from '../features/service/queries';
import ServiceFormDialog from '../features/service/components/service-form-dialog';
import { useRef } from 'react';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { useFormatCurrency } from '@features/currency/currency.hooks';

const PriceList = () => {
  const { data: services } = useServicesQuery();
  const { format: fmtCurrency } = useFormatCurrency();

  const columns = createServicesColumns(v => fmtCurrency(v, undefined, 0, 0));

  if (!services) {
    return null;
  }

  return (
    <Box sx={{ height: '100%' }}>
      <AppDataGrid rows={services} columns={columns} />
    </Box>
  );
};

export default PriceList;

export const renderServiceEditCell = (props: {
  id: string;
  basePrice: number;
  serviceName: string;
  blocks: WorkPauseBlock[];
  publicDescription: string | null | undefined;
  publicName: string | null | undefined;
}) => {
  const { id, basePrice, serviceName, blocks, publicDescription, publicName } = props;
  const editServiceDialogRef = useRef<ImperativeFormDialogRefType | null>(null);
  const deleteServiceDialogRef = useRef<ImperativeFormDialogRefType | null>(null);

  return (
    <>
      <Stack direction="row" spacing={1}>
        <BoxIcon
          size="small"
          onClick={() => editServiceDialogRef.current?.open()}
          key={id}
          icon={<EditOutlinedIcon fontSize="small" color="secondary" />}
          boxColor="secondary.light"
        />
        <BoxIcon
          size="medium"
          onClick={() => deleteServiceDialogRef.current?.open()}
          icon={<DeleteOutlineIcon fontSize="small" color="secondary" />}
          boxColor="primary.light"
        />
      </Stack>
      <ServiceFormDialog
        defaultValues={{
          id,
          basePrice,
          serviceName,
          blocks,
          publicDescription,
          publicName,
        }}
        dialogRef={editServiceDialogRef}
      />
      <DeleteServiceDialog serviceId={id} dialogRef={deleteServiceDialogRef} />
    </>
  );
};
